import { factory } from "@cems-eco/core/src/utils/platform";

import WebSystemComponent from "./system/system.web.vue";
import MobileSystemComponent from "./system/system.mobile.vue";
import CemsInfoComponent from "./info/info.vue";

import WebReadingComponent from "./reading/reading.web.vue";
import MobileReadingComponent from "./reading/reading.mobile.vue";

import AlarmComponent from "./alarm/alarm.vue";
import MapComponent from "./map/map.vue";
import StatusComponent from "./status/status.vue";

export default factory<any>({
    web: {
        AlarmComponent,
        SystemComponent: WebSystemComponent,
        ReadingComponent: WebReadingComponent,
        CemsInfoComponent,
        MapComponent,
        StatusComponent
    },
    mobile: {
        AlarmComponent,
        SystemComponent: MobileSystemComponent,
        ReadingComponent: MobileReadingComponent,
        CemsInfoComponent,
        MapComponent,
        StatusComponent
    },
});
